import React, { Component } from 'react';
import { Flex, Button, Tag } from 'antd-mobile';

export class More extends Component {
  constructor(props) {
   super(props);
    this.state = {
      priceC: this.props.priceC,
      priceData: this.props.priceData,
      tsC: this.props.tsC,
      screeningData: this.props.screeningData
    };
  }

  onChangeSalePrice = (searchSalePrice, selected) => {
    this.setState({ priceC: selected ? searchSalePrice : null }, () => {
    });
  }

  onChangeScreening = (Screening, selected) => {
    this.setState({ tsC: selected ? Screening : null }, () => {
    });
  }

  onReset = () => {
    this.setState({
      priceC: null,
      tsC:null
    });
  }

  render() {
    return (
      <div className="more">
         <div className="more-item">
          <h1>特色项目</h1>
          <div className="tag">
            <Flex>
            {
                this.state.screeningData.map((data, index) => (
                  <Tag key={index} onChange={this.onChangeScreening.bind(this, this.selected ? null : index)} selected={this.state.tsC === index ? true : false} >{data.label}</Tag>

                ))
              } 
            </Flex>            
          </div>
        </div>
        <div className="more-item">
          <h1>价格区间</h1>
          <div className="tag">
            <Flex>
              {
                this.state.priceData.map((data, index) => (
                  <Tag key={index} onChange={this.onChangeSalePrice.bind(this, this.selected ? null : index)} selected={this.state.priceC === index ? true : false} >{data.startprice}{data.endprice === '' ? '元以上' : '-' + data.endprice + '元'}</Tag>

                ))
              }
            </Flex>
          </div>
        </div>     

        <div className="more-button">
          <Flex>
            <Button type="primary" inline style={{ marginRight: '4%', backgroundColor: '#f5f5f5', color: '#666' }}
              onClick={this.onReset}>重置</Button>
            <Button type="primary" inline
              onClick={this.props.onOkMore.bind(this, this.state.priceC, this.state.tsC)}>确定</Button>
          </Flex>
        </div>
      {/* <div className="menu-mask" onClick={this.props.onCancel} />  */}
      </div>
    );
  }
};
